/* 🤖 this file was generated by script */
export const wiconChevronLeft = {
  name: 'chevron_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 18l-6-6 6-6"/></svg>`,
};
